import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.aside`
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.lg};
  padding: ${({ theme }) => theme.espaco.lg} ${({ theme }) => theme.espaco.md};
  background-color: ${({ theme }) => theme.cores.primary};
  color: ${({ theme }) => theme.cores.inkInverse};
  overflow-y: auto;
  z-index: ${({ theme }) => theme.zIndex.sidebar};

  ${media.mobile} {
    display: none;
  }

  @media print {
    display: none;
  }
`;

export const Usuario = styled.div`
  padding: 0 ${({ theme }) => theme.espaco.xs} ${({ theme }) => theme.espaco.lg};
  border-bottom: 1px solid ${({ theme }) => theme.cores.borderInverse};
`;
